<template>
  <div class="mobile-login-page">
    <div class="login-card">
      <div class="title">众鑫驾校学习系统</div>
      <div class="sub-title">手机端登录</div>

      <van-form @submit="handleLogin">
        <van-field
            v-model="loginForm.username"
            name="username"
            label="账号"
            placeholder="请输入账号"
            :rules="[{ required: true, message: '请输入账号' }]"
        />

        <van-field
            v-model="loginForm.password"
            type="password"
            name="password"
            label="密码"
            placeholder="请输入密码"
            :rules="[{ required: true, message: '请输入密码' }]"
        />

        <van-field
            v-model="loginForm.captcha"
            name="captcha"
            label="验证码"
            placeholder="请输入验证码"
            :rules="[{ required: true, message: '请输入验证码' }]"
        >
          <template #button>
            <img
                v-if="captchaImage"
                :src="captchaImage"
                class="captcha-img"
                @click="loadCaptcha"
            />
          </template>
        </van-field>

        <div class="button-area">
          <van-button
              round
              block
              type="info"
              native-type="submit"
              :loading="loading"
          >
            登录
          </van-button>
        </div>
      </van-form>
    </div>

    <div class="login-footer-mobile">
      <span>网站主办单位：郑州市众鑫机动车驾驶员培训学校有限公司</span>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
        豫ICP备2026017669号
      </a>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41010202003859" target="_blank" class="gongan-link">
        <img src="@/assets/gongan.png" alt="公安备案图标" class="gongan-icon" />
        豫公网安备41010202003859号
      </a>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getCaptcha, login, getCurrentUser } from '@/api/auth'
import { setToken, removeToken } from '@/utils/auth'
import { setClientType, getHomePathByRole } from '@/utils/device'

export default {
  name: 'MobileLogin',

  data() {
    return {
      loading: false,
      captchaImage: '',
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        captchaId: ''
      }
    }
  },

  created() {
    setClientType('mobile')
    this.loadCaptcha()
  },

  methods: {
    async loadCaptcha() {
      try {
        const res = await getCaptcha()

        if (res.code === 200) {
          this.captchaImage = res.data.imageBase64
          this.loginForm.captchaId = res.data.captchaId
        } else {
          Toast.fail(res.message || '获取验证码失败')
        }
      } catch (e) {
        Toast.fail('获取验证码失败')
      }
    },

    async handleLogin() {
      this.loading = true

      try {
        const res = await login(this.loginForm)

        if (res && res._handled401) {
          return
        }

        if (res.code !== 200) {
          Toast.fail(res.message || '登录失败')
          await this.loadCaptcha()
          return
        }

        const token = res.data ? res.data.token : ''
        if (!token) {
          Toast.fail('登录成功但未获取到 token')
          await this.loadCaptcha()
          return
        }

        setToken(token)

        const meRes = await getCurrentUser()

        if (meRes && meRes._handled401) {
          return
        }

        if (meRes.code !== 200) {
          removeToken()
          this.$store.commit('CLEAR_USER_INFO')
          Toast.fail(meRes.message || '获取当前用户信息失败')
          await this.loadCaptcha()
          return
        }

        const user = meRes.data || {}
        this.$store.commit('SET_USER_INFO', user)

        Toast.success('登录成功')

        this.$router.replace(getHomePathByRole(user.role, 'mobile'))
      } catch (e) {
        removeToken()
        this.$store.commit('CLEAR_USER_INFO')
        Toast.fail('登录失败')
        await this.loadCaptcha()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.mobile-login-page {
  min-height: 100vh;
  background: #f5f7fa;
  box-sizing: border-box;
  padding: 46px 18px 120px; /* 增加底部 padding，防止备案信息挡住输入框 */
  position: relative; /* 新增：为底部绝对定位提供参考 */
}

.login-card {
  background: #fff;
  border-radius: 14px;
  padding: 26px 16px 18px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

.title {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}

.sub-title {
  text-align: center;
  font-size: 14px;
  color: #909399;
  margin-bottom: 28px;
}

.captcha-img {
  width: 104px;
  height: 36px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.button-area {
  margin-top: 24px;
}

/* ================= 手机端 备案信息底部样式 ================= */
.login-footer-mobile {
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column; /* 手机端竖排显示 */
  align-items: center;
  gap: 8px; /* 每行之间的间距 */
  font-size: 12px;
  color: #909399; /* 浅色背景搭配灰色文字 */
}

.login-footer-mobile a {
  color: #909399;
  text-decoration: none;
}

.gongan-link {
  display: flex;
  align-items: center;
}

.gongan-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}
</style>